export default __webpack_public_path__ + "static/media/partner-icon.51a0bedf.svg";